/**
 * author: duxin
 * date: 2020/4/23
 * describe:
 */

const zh = {
    menu: {
        home: "首页",
        service: "服务内容",
        info: "资讯中心",
        about: "关于我们",
        job: "加入我们",
        contact: "联系我们",
        lang: "English",

        dm: "数据管理",
        biostatistics: "生物统计",
        sp: "统计编程",
        pharmacovigilance: "药物警戒",
        cc: "呼叫中心",

        company: "公司新闻",
        // industry: "行业新闻",
        industry: "与您分享",
        book: "新书推荐",

        companyInfo: "公司简介",
        children: "子公司",
    },
    home: {
        about: "关于我们",
        content1: `美达数据`,
        content11: `专业的临床试验数据服务`,
        content2: `美达临床数据技术有限公司(Meta Clinical Technology Co. Ltd)是一家主要承担国内及外国制药企业的临床试验中数据相关的服务外包业务的合同研究组织（Contract Research Organization, CRO），成立于2014年9月, 是全方位服务的北京科林利康医学研究有限公司的全资子公司,现在全国设有上海、西安、南京、沈阳、苏州、成都和台北等办事处。目前已为上百家国内外药企的创新药物和仿制药I-IV期及生物等效性临床试验提供了数据管理、统计分析、和药物警戒及呼叫中心服务。`,
        content3: "",
        values: "我们的核心价值观",
        valuesText: "质量、诚信、效率、仁爱",
        mission: "我们的使命",
        missionText: "以质量为本，服务医药产品研发，助力人类更健康",
        vision: "我们的愿景",
        visionText: "数据质量 完美则达",

        seeMore:"查看更多",

        services: "我们的服务",

        information: "我们的资讯",

        banner1:"世界大同，您我同行",
        banner2:"数据质量 完美则达",

    },
    about: {
        content1:`美达科林医药科技有限公司（以下简称“美达”）是科林利康医学研究有限公司全资子公司之一，主要提供临床数据管理、生物统计、统计编程等服务。目前拥有数百名数据管理统计分析的专业人才，可以根据客户需求量身定制数据管理和统计服务。
        按照国际标准，美达以先进的技术、流程及专业的团队给客户提供数据管理的系统服务。所有服务均遵循国内法规指导原则、ICH-GCP和US FDA 21 CFR Part 11规则，确保给客户提供最准确、及时、可信的临床试验数据。
        自创立起，美达参与了数百项临床试验，经历了百余项项目的国家局检查，协助了众多企业、包括头部传统药企和创新药企完成了药品上市工作。团队熟悉国内及国际临床试验设计和执行，并通晓国内外有关药品的管理法规和实施细则，团队内的多位专家更是参与了多项国际指导原则的制定和国内指导原则的撰写，在众多医疗领域积累了丰富的临床试验数据管理与统计经验，能够帮助客户更快更稳更好地完成药物的上市工作。
        `,
        content2:"",

        journey:"我们的历程",
        history2019:"台北办事处正式落成，美达科林励志不断为全球客户和合作伙伴提供优质的、专业的服务。",
        history2018:"科林利康全资子公司“美达科林（南京）医药科技有限公司”成立 ，美达临床数据业务逐步过渡到美达科林，逐步实现强强联合。",
        history2017:"正式在上海浦东启用独立办公室，上海办团队成员增加至20人左右，上海办作为美达主办公区域正式运行。",
        history2016:"10月沈阳办成立，沈阳初建团队成员10人，数据管理团队逐步壮大。",
        history2014:"美达临床数据技术有限公司于陕西西安市正式成立，主要业务范围包含数据管理、生物统计等",

        honor:"我们的荣誉",
        honor2014:["2014中国医学科学院肿瘤医院年度临床试验质控评选优秀团队"],
        honor2015:["2015中国医学科学院肿瘤医院年度临床试验质控评选优秀团队"],
        honor2016:["美达数据获得创新创业大赛西北赛区一等奖","2016中国医学科学院肿瘤医院年度临床试验质控评选优秀团队"],
        honor2018:["高新技术企业"],
        honor2019:["成为中国化学制药工业协会会员单位","1人被聘为中国抗癌协会第一届中西医整合肿瘤专业委员会早期临床试验研究组副组长，7人被聘为委员。","1人被聘为第一届临床研究委员会委员"],

        team:"我们的团队",

        meta:"美达临床数据技术有限公司是一家科林利康全资的子公司，为国内外制药企业提供临床数据管理、生物统计、统计编程、药物警戒和呼叫中心服务的合同研究组织。",
        metaName:"美达临床数据技术有限公司",
        CRiC:"科睿克（北京）临床医学研究有限公司是科林利康旗下的国内专业的临床试验现场管理组织。目前团队成员分布在全国50个以上的城市，覆盖了300余家机构，与多家机构结成战略合作伙伴。科睿克始终把质量放在首位，致力于寻求中国临床试验现场管理解决之道。从公司成立至今，所有科睿克人不断开拓创新，秉承高效高品质的原则，积极配合申办方、研究者完成每一个项目。我们已完成与正在进行的项目超过300个，其中30%为国际多中心项目，所负责的大部分项目接受了权威机构的稽查和省级药政监管当局，国家局的现场核查，获得申办方与研究中心一致好评。",
        CRiCName:"科睿克（北京）临床医学研究有限公司",
        sz:"科林利康（苏州）医学研究有限公司是北京科林利康医学研究有限公司的全资子公司。业务范围包括早期临床研究、医学写作、医学监察、医学策略、第三方独立影像评估、中国及美国药政事务。我们拥有专业稳定的团队及良好的行业内资源，不断致力于为客户提供优质服务，达成客户产品开发的目标。",
        szName:"科林利康（苏州）医学研究有限公司",

        more:"了解更多",
        culture: "企业文化",
        honor: "荣誉表扬"
    },
    common:{
        companyName:"美达数据",
        companyInfo: "公司简介",
        children: "分公司",
    },
    // 联系我们
    contact: {
        contact: '联系我们',
        addBJ: '苏州总部服务热线',
        welcome: '欢迎致信',
        nameBJ: '北京办公室',
        regionalOffice: '区域办公室',
        infoBJ: '北京市朝阳区三间房南里四号院Dream2049产业园主楼C01栋302室 100024',
        nameSH: '上海办公室',
        infoSH: '上海市浦东新区向城路58号东方国际科技大厦20楼A室 200122\n电话：021-64729901',
        nameCD: '成都办公室',
        infoCD: '四川省成都市锦江区新光华街7号航天科技大厦2907  610041',
        nameGZ: '广州办公室',
        infoGZ: '广州市越秀区中山三路33号中华国际中心B座1506   510030',
        nameXiAn: '西安办公室',
        infoXiAn: '西安市未央区凤城三路与太华北路东南角汇景国际广场世纪未来中心2308室 710021',
        nameSY: '沈阳办公室',
        infoSY: '辽宁省沈阳市皇姑区北陵大街21号，平安财富中心1009室',
        nameNJ: '南京高淳办公室',
        infoNJ: '江苏高淳经济开发区古檀大道3号科创大楼307室  211300',
        nameSB: '南京市区办事处',
        infoSB: '南京市鼓楼区华侨路 56 号大地大厦 2303-2306 室',
        nameTJ: '天津办公室',
        infoTJ: '天津市南开区融汇广场金融街中心A座907',
        nameSZ: '苏州总部',
        infoSZ: '江苏省苏州市工业园区裕新路108号中科院药物所苏研院2层A211  215000\n电话：0512-67990267',
        nameTB: '台北办公室',
        infoTB: '台北市中山區民生東路三段2號7樓',
        nameHZ: '杭州办公室',
        infoHZ: '杭州市上城区花园兜街177号恒褀商务中心克拉天玺B座4幢12楼B005',
        nameWH: '武汉办公室',
        infoWH: '武汉市江汉区江汉北路南国中心T1栋22楼02号',
        nameZZ: '郑州办公室',
        infoZZ: '郑州市金水区姚砦路133号金成时代广场6号楼西门三层308单元',
        locateMe: '定位到我',
        geolocationNotSupported: '您的浏览器不支持地理位置定位',
        permissionDenied: '您拒绝了定位权限',
        positionUnavailable: '无法获取您的位置',
        geolocationTimeout: '定位超时，请重试',
        geolocationError: '定位失败，请稍后再试'
    },
    // 表单
    fromData: {
        name: '您的名称',
        position: '您的职位',
        company: '企业名称',
        email: '邮箱',
        phone: '联系电话',
        productName: '产品名字',
        productType: '产品类型',
        origin: '原产地',
        newOrGeneric: '新药或仿制药',
        cureSphere: '治疗领域',
        indication: '适应症',
        indicationZh: '计划在中国的适应症',
        stage: '中国以外的开发进展或分期',
        cooperativeIntention: '合作意向',
        remark: '其他信息',
        more: '更多',
        moreText: `* 为了帮助您在中国找到潜在的合作伙伴，我们可能会向可能匹配的第三方提供上述信息（部分或全部）。按发送即表示您同意我们的双方保密协议。`,
        btnText: '同意并发送',
        captcha: '图形验证码',
        captchaEmpty: '请输入图形验证码',
        sendOk: '发送成功！',
        sendText: '我们会尽快与您取得联系，谢谢！',
        fromRules: '请填写正确信息',
        error: '错误',
        systemError: '系统错误',
        contact:'合作洽谈'
    },
    help: {
        helpWays: '我们如何帮助您',
        company: '合作&伙伴',
        helpContent: '请尽可能详细地填写下面的表格，以便我们为您制定最佳匹配方案我们将评估您下面提供的信息，以了解您的业务需求，以便我们为您提供相匹配的数据和资源。',
        area: '治疗领域',
    },
    join: {
        values: '我们的信念',
        quality:"不懈努力于科学与新型医药治疗之间的开创性探索，世界必将充满生机和健康",
        platform:`职业规划大师之见：
未来的世界：方向比努力重要，能力比知识重要，健康比成绩重要，生活比文凭重要，情商比智商重要。——清华大学校长
科林利康为每位员工提供了畅通的职业发展路径，入职科林利康的每位员工可以参加科林利康大学堂在线学习，职业路径设置明晰：
职业路径畅通：临床数据团队从初级临床数据管理员到部门总监；
多条职业路径选择：监查团队可从临床项目助理到临床监查主管、质量控制主管，或高级项目经理；
量身定做的职业路径：临床协调团队可从预备临床研究协调员到培训带教老师、大区经理、或高级项目经理。`,
        mission:'我们的愿景',
        missionText:'数据质量 完美则达',
        joinTitle:'招贤纳才',
        find:"点击进入",
        team:"团队建设",
        teamContent:"我们尊重每一位员工，并倡导践行“简单开放、极致执行、团队协作、创业心态、拥抱变化”的团队管理文化。我们倡导健康丰富的团队活动和员工关怀，每年最少一次全体员工大型团建活动；重大节日有暖心的福利，也会在各地办公室举办小型庆祝派对；每个季度还会开展一次员工生日会；部门也会定期单独安排团建等等，始终致力于为优秀人才创造更轻松和谐、更富创造力、更具激情的工作环境和团队氛围。",


        career:"发展平台",
        careerContent:`未来的世界：方向比努力重要，能力比知识重要，健康比成绩重要，生活比文凭重要，情商比智商重要。
——清华大学校长
美达数据为每位员工提供了畅通明晰的职业发展路径，职业路径设置明晰：
职业路径畅通：临床数据团队从初级临床数据管理员到部门总监。`,

        talent :"人才培养",
        talentContent:`完善高效的培训体系，帮助各层级员工规划和设计培训课程、培训项目，助力企业实现专业人才、管理人才及复合型人才个性化发展战略。开设“科林利康大学堂”、“科林利康网络学院”等线上、线下平台，以此为依托，为员工提供多元化职业教育课程，有助于提升员工的工作能力和软技能等，促进员工成长、晋升。
与中国药科大学合作，联合培养临床药学方向专业硕士研究生。并与中国药科大学一起联合举办美国临床监查员认证培训，为中国制药研发企业和相关机构不断输送临床试验专业人才。`,
        application: '申请职位',
        more: '更多',
        jobDetail: '职位详情',
        jobDuties: '工作职责',
        jobRequirements: '任职要求',
        welfare: '福利信息',
        applicantName: '姓名',
        gender: '性别',
        birthday: '出生日期',
        mobile: '手机号码',
        email: '邮件地址',
        education: '学历',
        academy: '毕业院校',
        city: '期望工作城市',
        clinicalExperience: '是否有临床经验',
        file: '简历上传',
        male: '男',
        female: '女',
        yes: '是',
        no: '否',
        selectFile: '选择文件',
        desc: '只能上传pdf文件',
        submit: '提交',
        clinical: '北京科林利康医学研究有限公司',
        meta: '美达临床数据技术有限公司',
        cric: '科睿克（北京）临床医学研究有限公司',
        specialist: '专科',
        undergraduate: '本科',
        master: '硕士',
        doctor: '博士',
    },
    // 底部
    footer:{
        company:'Copyright © 2020 美达临床数据技术有限公司 版权所有',
        compangCode: '沪ICP备2024102626号-1',
        tel:'电话：021-64729901/02/03',
        fax:'传真分机号：6020',
        email:'邮箱：bd@meta-clinical.com',
        // web:'网址：www.clinicalservice.cn',
        address:'地址：上海市浦东新区向城路58号东方国际科技大厦20楼A室',
        code:'邮编：200031',
        szName: "苏州科林利康医药科技股份有限公司",
    },
    // 媒体及投资者关系
    media: {
        mediaInvestor: "媒体及投资者关系",
        submit: "提交",
        reset: "重置",
        SJob: "社会招聘",
        CJob: "校园招聘",
        InternJob: "实习生招聘",
        reJob: "岗位招聘",
        contactWay: "联系方式",
    }
};
export default zh;
